export default "__VITE_ASSET__PD7tZVUf__"